import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import store from './store'
import VueLazyLoad from 'vue3-lazyload'
import { plugin, defaultConfig } from '@formkit/vue'

// Create the Application instance
const Application = createApp(App)

// Check if Vue is disabled (for project pages)
if (window.__VUE_DISABLED__) {
  // Don't initialize Vue app for project pages
  console.log('Vue app disabled for project pages');
} else {
  Application.use(router)
    .use(VueLazyLoad, {
      adapter: {
        loaded ({
          bindType,
          el,
          naturalHeight,
          naturalWidth,
          $parent,
          src,
          loading,
          error,
          Init
        }) {
          setTimeout(() => el.classList.add('loaded'), 100)
        }
      }
    })
    // .use(VueGtag, {
    //   config: { id: 'GTM-N6SQCXW' }
    // }, router)
    .use(plugin, defaultConfig)
    .use(store)
    .mount('#app')
  router.beforeEach((to, from, next) => {
    next()
  })
}

export { Application }
